define("shared/types/social-profile", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.SocialProfileCode = _exports.SocialPlatformType = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  let SocialPlatformType = _exports.SocialPlatformType = /*#__PURE__*/function (SocialPlatformType) {
    SocialPlatformType["Facebook"] = "Facebook";
    SocialPlatformType["Instagram"] = "Instagram";
    SocialPlatformType["LinkedIn"] = "LinkedIn";
    SocialPlatformType["Pinterest"] = "Pinterest";
    SocialPlatformType["Threads"] = "Threads";
    SocialPlatformType["TikTok"] = "TikTok";
    SocialPlatformType["Twitter"] = "Twitter";
    SocialPlatformType["Unknown"] = "";
    SocialPlatformType["Youtube"] = "Youtube Shorts";
    return SocialPlatformType;
  }({});
  let SocialProfileCode = _exports.SocialProfileCode = /*#__PURE__*/function (SocialProfileCode) {
    SocialProfileCode["Facebook"] = "fb";
    SocialProfileCode["Instagram"] = "ig";
    SocialProfileCode["LinkedIn"] = "li";
    SocialProfileCode["Pinterest"] = "pin";
    SocialProfileCode["Threads"] = "th";
    SocialProfileCode["Tiktok"] = "tk";
    SocialProfileCode["Twitter"] = "tw";
    SocialProfileCode["Youtube"] = "yt";
    return SocialProfileCode;
  }({});
});